import { useEffect, useState } from "react";
import {
    Zap,
    Search,
    ArrowRight,
    CheckCircle,
    AlertCircle,
    Trash2,
    PlusCircle,
    Server
} from "react-feather";
import ContaContabilService from "../../services/resource/ContaContabilService";
import CentroCustoService from "../../services/resource/CentroCustoService";
import DespesaService from "../../services/resource/DespesaService";
import ReceitaService from "../../services/resource/ReceitaService";
import ApiClientService from "../../services/resource/ApiClient";
import LogsTab from "./LogsTab";

export function Config() {
    const contaContabilService = new ContaContabilService();
    const centroCustoService = new CentroCustoService();
    const despesasService = new DespesaService();
    const receitaService = new ReceitaService();
    const apiClientService = new ApiClientService();

    const [loading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("");
    const [loadingMessage, setLoadingMessage] = useState("");
    const [notification, setNotification] = useState(null);

    const [activeTab, setActiveTab] = useState("geral");

    // === SINCRONIZAÇÃO DE DESPESAS ===
    const hoje = new Date();
    const formatarData = (d) => {
        const mes = String(d.getMonth() + 1).padStart(2, "0");
        const dia = String(d.getDate()).padStart(2, "0");
        return `${d.getFullYear()}-${mes}-${dia}`;
    };
    const [despesaInicio, setDespesaInicio] = useState(
        formatarData(new Date(hoje.getFullYear(), hoje.getMonth(), 1))
    );
    const [despesaFim, setDespesaFim] = useState(formatarData(hoje));

    // === API CLIENTS ===
    const [apiClients, setApiClients] = useState([]);
    const [novoNome, setNovoNome] = useState("");

    useEffect(() => {
        carregarApiClients();
        document.title = "MyDash | Configurações"
    }, [])

    const showNotification = (message, type) => {
        setNotification({ message, type });
        setTimeout(() => setNotification(null), 3000);
    };

    const buscarContasContabil = () => {
        setLoading(true);

        setLoadingTitle("Buscando Atualizações");
        setLoadingMessage(
            "Estamos sincronizando os dados mais recentes da sua conta contábil."
        );

        contaContabilService.sincronizar().then(response => {
            setTimeout(() => {
                setLoading(false);
                showNotification("As Contas Contábéis foram atualizadas com sucesso!", "success");
            }, [1000])
        }).catch(() => {
            setLoading(false);
            showNotification("Erro ao sincronizar Contas Contábil com Fortes!", "error");
        })
    };

    const buscarCentroCusto = () => {
        setLoading(true);

        setLoadingTitle("Buscando Atualizações");
        setLoadingMessage(
            "Estamos sincronizando os dados mais recentes do seu centro de custo."
        );

        centroCustoService.sincronizar().then(response => {
            setTimeout(() => {
                setLoading(false);
                showNotification("Os centros de custo foram atualizadas com sucesso", "success");
            }, [1000])
        }).catch(() => {
            setLoading(false);
            showNotification("Erro ao sincronizar Centro de Custo com Fortes!", "error");
        })
    };

    const atualizaDespesas = () => {
        if (!despesaInicio || !despesaFim) {
            showNotification("Informe o período para sincronizar as despesas", "error");
            return;
        }
        if (despesaInicio > despesaFim) {
            showNotification("A data inicial não pode ser maior que a data final", "error");
            return;
        }

        setLoading(true);

        setLoadingTitle("Buscando Atualizações");
        setLoadingMessage(
            "Estamos sincronizando as despesas lançadas (Logístico e Transportadora)."
        );

        despesasService.atualizaDespesas(despesaInicio, despesaFim).then(response => {
            setTimeout(() => {
                setLoading(false);
                showNotification("Os lançamentos de despesas foram atualizados com sucesso", "success");
            }, [1000])
        }).catch((e) => {
            setLoading(false);
            showNotification(typeof e === "string" ? e : "Erro ao atualizar despesas", "error");
        })
    };

    const atualizaReceitas = () => {
        setLoading(true);

        setLoadingTitle("Buscando Atualizações");
        setLoadingMessage(
            "Estamos sincronizando as receitas lançadas (Logístico e Transportadora)."
        );

        receitaService.atualizaReceitas().then(() => {
            setTimeout(() => {
                setLoading(false);
                showNotification("As receitas foram atualizadas com sucesso", "success");
            }, 1000)
        }).catch((e) => {
            setLoading(false);
            showNotification(typeof e === "string" ? e : "Erro ao atualizar receitas", "error");
        })
    };

    const carregarApiClients = async () => {
        apiClientService.listar().then(response => {
            setApiClients(response.data);
        }).catch(error => {
            console.error(error);
            showNotification("Erro ao carregar API Clients", "error");
        });
    };

    const criarApiClient = async () => {
        if (!novoNome.trim()) {
            showNotification("Informe um nome para o cliente", "error");
            return;
        }

        apiClientService.criar(novoNome).then(response => {
            setNovoNome("");
            showNotification("Cliente criado com sucesso!", "success");
            carregarApiClients();
        }).catch(error => {
            showNotification("Erro ao criar cliente", "error");

        });
    };

    const excluirApiClient = async (id) => {
        if (!window.confirm("Deseja realmente excluir este cliente?")) return;

        apiClientService.excluir(id).then(response => {
            showNotification("Cliente excluído com sucesso!", "success");
            carregarApiClients();
        }).catch((error) => {
            console.error(error);
            showNotification("Erro de rede ao excluir cliente", "error");
        })
    };

    return (
        <div className="bg-background min-h-screen flex flex-col">
            <main className="flex-grow container px-4 py-8">
                <div className="container">
                    {/* === Abas === */}
                    <div className="mb-6 flex space-x-4 border-b border-border">
                        <button
                            className={`pb-2 font-medium transition-colors duration-150 ${activeTab === "geral"
                                ? "text-primary border-b-2 border-primary"
                                : "text-muted-foreground hover:text-foreground"
                                }`}
                            onClick={() => setActiveTab("geral")}
                        >
                            Geral
                        </button>
                        <button
                            className={`pb-2 font-medium transition-colors duration-150 ${activeTab === "apiClients"
                                ? "text-primary border-b-2 border-primary"
                                : "text-muted-foreground hover:text-foreground"
                                }`}
                            onClick={() => setActiveTab("apiClients")}
                        >
                            API Clients
                        </button>
                        <button
                            className={`pb-2 font-medium transition-colors duration-150 ${activeTab === "logs"
                                ? "text-primary border-b-2 border-primary"
                                : "text-muted-foreground hover:text-foreground"
                                }`}
                            onClick={() => setActiveTab("logs")}
                        >
                            LOGS do Sistema
                        </button>
                    </div>

                    {/* === Aba Geral (conteúdo original) === */}
                    {activeTab === "geral" && (
                        <div className="surface-card p-6 mb-8">
                            <div className="flex items-center space-x-4 mb-4">
                                <Zap className="text-primary w-6 h-6" />
                                <h2 className="font-display text-xl font-semibold text-foreground">Configurações Rápidas</h2>
                            </div>
                            <p className="text-muted-foreground mb-6">
                                Gerencie suas integrações contábeis e despesas de forma simples e eficiente.
                            </p>

                            <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
                                <div className="border border-border rounded-lg p-5 hover:shadow-card transition-all duration-150">
                                    <div className="flex items-center space-x-3 mb-4">
                                        <div className="bg-accent p-2 rounded-lg">
                                            <i className="text-primary fa fa-file-invoice" />
                                        </div>
                                        <h3 className="font-medium text-foreground">
                                            Buscar Atualizações de Conta Contábil
                                        </h3>
                                    </div>
                                    <p className="text-muted-foreground text-sm mb-4">
                                        Sincronize os dados mais recentes da sua conta contábil com sistema Fortes.
                                    </p>
                                    <button
                                        onClick={buscarContasContabil}
                                        className="w-full bg-primary hover:brightness-95 text-primary-foreground py-2 px-4 rounded-lg flex items-center justify-center space-x-2 transition-all duration-150"
                                    >
                                        <span>Buscar Agora</span>
                                        <ArrowRight className="w-4 h-4" />
                                    </button>
                                </div>

                                <div className="border border-border rounded-lg p-5 hover:shadow-card transition-all duration-150">
                                    <div className="flex items-center space-x-3 mb-4">
                                        <div className="bg-accent p-2 rounded-lg">
                                            <i className="text-primary fas fa-project-diagram" />
                                        </div>
                                        <h3 className="font-medium text-foreground">
                                            Buscar Atualizações de Centro de Custo
                                        </h3>
                                    </div>
                                    <p className="text-muted-foreground text-sm mb-4">
                                        Sincronize os dados mais recentes do Centro de Custo com sistema Fortes.
                                    </p>
                                    <button
                                        onClick={buscarCentroCusto}
                                        className="w-full bg-primary hover:brightness-95 text-primary-foreground py-2 px-4 rounded-lg flex items-center justify-center space-x-2 transition-all duration-150"
                                    >
                                        <span>Buscar Agora</span>
                                        <ArrowRight className="w-4 h-4" />
                                    </button>
                                </div>

                                <div className="border border-border rounded-lg p-5 hover:shadow-card transition-all duration-150">
                                    <div className="flex items-center space-x-3 mb-4">
                                        <div className="bg-muted p-2 rounded-lg">
                                            <Search className="text-secondary-foreground w-5 h-5" />
                                        </div>
                                        <h3 className="font-medium text-foreground">Sincronizar Despesas</h3>
                                    </div>
                                    <p className="text-muted-foreground text-sm mb-4">
                                        Sincronize manualmente as despesas do Fortes (Logístico e Transportadora) no período.
                                    </p>
                                    <div className="grid grid-cols-2 gap-2 mb-4">
                                        <input
                                            type="date"
                                            value={despesaInicio}
                                            onChange={(e) => setDespesaInicio(e.target.value)}
                                            className="border border-input rounded-lg px-2 py-2 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                                        />
                                        <input
                                            type="date"
                                            value={despesaFim}
                                            onChange={(e) => setDespesaFim(e.target.value)}
                                            className="border border-input rounded-lg px-2 py-2 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                                        />
                                    </div>
                                    <button
                                        onClick={atualizaDespesas}
                                        className="w-full bg-primary hover:brightness-95 text-primary-foreground py-2 px-4 rounded-lg flex items-center justify-center space-x-2 transition-all duration-150"
                                    >
                                        <span>Sincronizar</span>
                                        <ArrowRight className="w-4 h-4" />
                                    </button>
                                </div>

                                <div className="border border-border rounded-lg p-5 hover:shadow-card transition-all duration-150">
                                    <div className="flex items-center space-x-3 mb-4">
                                        <div className="bg-accent p-2 rounded-lg">
                                            <i className="text-primary fas fa-chart-line" />
                                        </div>
                                        <h3 className="font-medium text-foreground">Sincronizar Receitas</h3>
                                    </div>
                                    <p className="text-muted-foreground text-sm mb-4">
                                        Sincronize manualmente as receitas do Fortes (Logístico e Transportadora) de 01/01/2026 até o fim do mês atual.
                                    </p>
                                    <button
                                        onClick={atualizaReceitas}
                                        className="w-full bg-primary hover:brightness-95 text-primary-foreground py-2 px-4 rounded-lg flex items-center justify-center space-x-2 transition-all duration-150"
                                    >
                                        <span>Sincronizar</span>
                                        <ArrowRight className="w-4 h-4" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* === Aba API Clients === */}
                    {activeTab === "apiClients" && (
                        <div className="surface-card p-6">
                            <div className="flex items-center space-x-3 mb-6">
                                <Server className="text-primary w-6 h-6" />
                                <h2 className="font-display text-xl font-semibold text-foreground">Gerenciar API Clients</h2>
                            </div>

                            {/* Formulário de cadastro */}
                            <div className="flex flex-wrap gap-2 space-x-2 mb-6">
                                <input
                                    type="text"
                                    placeholder="Nome do cliente"
                                    value={novoNome}
                                    onChange={(e) => setNovoNome(e.target.value)}
                                    className="border border-input rounded-lg px-3 py-2 flex-1 transition-colors duration-150 focus:border-primary focus:ring-2 focus:ring-primary/15 outline-none"
                                />
                                <button
                                    onClick={criarApiClient}
                                    className="bg-primary hover:brightness-95 text-primary-foreground px-4 py-2 rounded-lg flex items-center space-x-2 transition-all duration-150"
                                >
                                    <PlusCircle className="w-5 h-5" />
                                    <span>Adicionar</span>
                                </button>
                            </div>

                            {/* Tabela */}
                            <div className="overflow-x-auto">
                                <table className="w-full border border-border text-sm rounded-md overflow-hidden">
                                    <thead className="bg-table-header text-table-header-fg">
                                        <tr>
                                            <th className="px-4 py-2 text-left">ID</th>
                                            <th className="px-4 py-2 text-left">Nome</th>
                                            <th className="px-4 py-2 text-left">Client ID</th>
                                            <th className="px-4 py-2 text-left">Token</th>
                                            <th className="px-4 py-2 text-center">Ativo</th>
                                            <th className="px-4 py-2 text-center">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {apiClients.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan="6"
                                                    className="text-center text-muted-foreground py-4"
                                                >
                                                    Nenhum cliente cadastrado.
                                                </td>
                                            </tr>
                                        ) : (
                                            apiClients.map((client) => (
                                                <tr
                                                    key={client.id}
                                                    className="border-t border-table-border hover:bg-table-row-hover transition-colors duration-150"
                                                >
                                                    <td className="px-4 py-2">{client.id}</td>
                                                    <td className="px-4 py-2">{client.nome}</td>
                                                    <td className="px-4 py-2 font-mono text-xs">{client.clientId}</td>
                                                    <td className="px-4 py-2 font-mono text-xs">{client.token}</td>
                                                    <td className="px-4 py-2 text-center">
                                                        {client.ativo ? (
                                                            <CheckCircle className="w-4 h-4 text-success inline" />
                                                        ) : (
                                                            <AlertCircle className="w-4 h-4 text-muted-foreground inline" />
                                                        )}
                                                    </td>
                                                    <td className="px-4 py-2 text-center">
                                                        <button
                                                            onClick={() => excluirApiClient(client.id)}
                                                            className="text-destructive hover:brightness-90 transition-all duration-150"
                                                        >
                                                            <Trash2 className="w-4 h-4" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* === Aba Logs do Sistema   ===*/}
                    {activeTab === "logs" && (
                        <LogsTab />
                    )
                    }
                </div>
            </main>

            {/* Loading Modal */}
            {loading && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-card rounded-xl p-6 max-w-sm w-full mx-4 shadow-pop">
                        <div className="flex flex-col items-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
                            <h3 className="font-display text-lg font-medium text-foreground mb-2">{loadingTitle}</h3>
                            <p className="text-muted-foreground text-center">{loadingMessage}</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Notification */}
            {notification && (
                <div
                    className={`fixed bottom-4 right-4 px-4 py-3 rounded-lg shadow-pop text-white flex items-center space-x-2 transition duration-300 ${notification.type === "success"
                        ? "bg-success"
                        : "bg-destructive"
                        }`}
                >
                    {notification.type === "success" ? (
                        <CheckCircle className="w-5 h-5" />
                    ) : (
                        <AlertCircle className="w-5 h-5" />
                    )}
                    <span>{notification.message}</span>
                </div>
            )}
        </div>
    );
}

